import { useDispatch } from "react-redux"
import { setNewConsignments } from "redux/OrderData/OrderData"
import { getAPI } from "services/CRUDServices"

export  function useGetInternalOrderConsignments() {
  const dispatch = useDispatch()
  async function getInternalOrderConsignments(orderId) {
    const res = await getAPI(
      `/consignment-api/internalConsignmentWizard/order/${orderId}`
    )
    dispatch(setNewConsignments(res.data.payload))

    

  }

  return {getInternalOrderConsignments}
}
